import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { MyComponent } from './my.component';
import { MyChartGuard } from './routes/my-chart/my-chart.guard';
import { MyDocumentComponent } from './routes/my-document/my-document.component';

const routes: Routes = [
  {
    path: '',
    component: MyComponent,
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'home' },
      {
        path: 'home',
        loadChildren: () =>
          import('./routes/my-home/my-home.module').then((m) => m.MyHomeModule),
      },
      {
        path: 'messages',
        loadChildren: () =>
          import('./routes/my-message/my-message.module').then(
            (m) => m.MyMessageModule,
          ),
      },
      {
        path: 'documents',
        component: MyDocumentComponent,
        loadChildren: () =>
          import('./routes/my-document/my-document.module').then(
            (m) => m.MyDocumentModule,
          ),
      },
      {
        path: 'charts',
        canActivate: [MyChartGuard],
        loadChildren: () =>
          import('./routes/my-chart/my-chart.module').then(
            (m) => m.MyChartModule,
          ),
      },
      {
        path: 'profile',
        loadChildren: () =>
          import('./routes/my-profile/my-profile.module').then(
            (m) => m.MyProfileModule,
          ),
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class MyRoutingModule {}
